<template>
  <div class="aboutus-box" v-if="data">
    <GoBackView />
    <WebHeaderView />
    <div class="img-box">
      <img :src="data.default_info.img" />
    </div>
    <div style="display: flex;gap: 5px;">
      <div style="width: 80px;">
        <van-sidebar v-model="activeKey" @change="ChangeVal">
          <van-sidebar-item
            v-for="(item, index) in list"
            :key="index"
            :title="item.title"
          />
        </van-sidebar>
      </div>
      <div style="padding: 10px;flex: 1;    max-width: calc(100vw - 100px);">
        <div v-html=" this.list[0].content" v-if="activeKey == 0"></div>
        <div v-else>
          <div v-for="(item,index) in this.list[activeKey].children" :key="index" class="area"
            :style="'background-image: url(' +item.img+ ');'"
          >
            <div class="title">
              <div class="icon">
                <img :src="item.img" />
              </div>
              <div class="text">{{ item.title }}</div>
              </div>
              <div style="margin: 10px 0;word-wrap: break-word;word-break: break-all;white-space: normal;" v-html="item.content" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WebHeaderView from '@/components/header/index.vue'
import GoBackView from '@/components/goback/index.vue'
export default {
  name: 'AboutUsView',
  components: { WebHeaderView, GoBackView },
  data () {
    return {
      data: null,
      activeKey: 0,
      list: []
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      await this.$http({
        method: 'post',
        url: 'getContentIndex'
      }).then(res => {
        this.data = res.data
        this.list.push(res.data.default_info)
        res.data.type_list.forEach(element => {
          this.list.push(element)
        })
      })
    },
    ChangeVal(val){
      console.log(val)
    }
  }
}
</script>
<style lang="scss" scoped>
.aboutus-box {
  background: #fff;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  .img-box {
    width: 100%;
    img {
      width: 100%;
      height: auto;
    }
  }
  .area {
    border-radius: 10px;
    box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
    padding: 15px;
    margin: 20px 10px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .title {
      height: 28px;
      display: flex;
      gap: 8px;
      .icon {
        display: none;
        margin: 2;
        width: 24px;
        height: 24px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .text{
        font-size: 18px;
        font-weight: 550;
        height: 28px;
        line-height: 28px;
      }
    }
  }
}
</style>
<style>
.van-sidebar-item--select::before {
  background-color: #c9952c !important;
}
</style>
